module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    class: {
      'has-navigation': _vm.hasNavigation,
      'has-footer-bar': _vm.hasFooterBar,
      'page-login': _vm.login,
      'page-empty': _vm.empty,
      'page-backend': _vm.backend && !_vm.empty,
        'page-wizard': _vm.wizard,
        'touch-device': _vm.touchDevice,
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.updated) ? _c('div', {
    staticClass: "update-notification"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('page.update.headline')))]), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('page.update.text'))), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.updateApp()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.update.button')))])]) : _vm._e(), _vm._v(" "), (_vm.maintenance) ? _c('div', {
    staticClass: "update-notification"
  }, [_c('h1', [_vm._v("ONDURO will be right back!")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("We're performing a maintenance update and will be back in a moment.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Please try again later or by clicking on the button below.")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.updateApp()
      }
    }
  }, [_vm._v("Reload")])]) : _vm._e(), _vm._v(" "), (_vm.empty) ? _c('empty') : _vm._e(), _vm._v(" "), (_vm.backend && !_vm.maintenance) ? _c('backend') : _vm._e(), _vm._v(" "), (_vm.frontend) ? _c('frontend') : _vm._e(), _vm._v(" "), (_vm.wizard) ? _c('wizard') : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('invoice') : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "modal"
  }), _vm._v(" "), _c('flash', {
    ref: "flash"
  }), _vm._v(" "), _c('widget', {
    ref: "modal"
  }), _vm._v(" "), _c('loader', {
    ref: "loader"
  }), _vm._v(" "), _c('toolbox', {
    ref: "toolbox"
  }), _vm._v(" "), _c('confirm', {
    ref: "confirm"
  }), _vm._v(" "), _c('notification', {
    ref: "notification"
  }), _vm._v(" "), (_vm.authenticated) ? _c('university', {
    ref: "university"
  }) : _vm._e(), _vm._v(" "), _c('lesson', {
    ref: "lesson"
  }), _vm._v(" "), _c('tooltip')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "max-width": "90%"
    },
    attrs: {
      "src": "/static/maintenance.gif"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a75201e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/App.vue
// module id = 498
// module chunks = 234